import React from 'react'

export default function Flare1() {
  return (
    <div className='flare-1'>
      <div className='source'></div>
      <div className='source-beam'></div>
    </div>
  )
}
